import { ConfoundingNodesReq, ConfoundingNodesDef } from "../type/node-def";

export class ConfoundingNodesAdapter {
  static toInputDTO(req: ConfoundingNodesReq): any {
    return {
      outcome_node: req.outcome_node,
      treatment_node: req.treatment_node,
      asset_id: req.asset_id,
    };
  }

  static toOutputDTO(data: any): ConfoundingNodesDef {
    return {
      necessary_confounders: data.necessary_confounders || [],
      covariates_count_list: data.covariates_count_list?.map((node: any) => ({
        name: node.name,
        value: node.value,
        score: node.score,
        lag: node.lag,
        user_count: node.user_count,
        time_count: node.time_count,
        missing_value_ratio: node.missing_value_ratio,
        layer: {
          no: node.layer?.no,
          color: node.layer?.color
        }
      })) || [],
    };
  }
}